import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Tabs,
  Tab,
  Box,
  TextField,
} from "@mui/material";
import AddFaq from "../../Modals/addFaq";
import AddIcon from "@mui/icons-material/Add";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import SwitchToggle from "../../components/SwitchToggle";
import AddCMSPage from "../../Modals/addCmsPage";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCms = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const [openModal2, setOpenModal2] = useState(false);
  const handleCloseModal2 = () => {
    setOpenModal2(false);
  };

  const [isEdit, setIsEdit] = useState(false);

  const faqList = [
    {
      id: 1,
      question: "FAQ title here",
      answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      date: "12 Jan 2024",
      status: true
    },
    {
      id: 2,
      question: "FAQ title here",
      answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      date: "12 Jan 2024",
      status: true
    },
    {
      id: 3,
      question: "FAQ title here",
      answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      date: "12 Jan 2024",
      status: true
    },
    {
      id: 4,
      question: "FAQ title here",
      answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      date: "12 Jan 2024",
      status: true
    },
    {
      id: 5,
      question: "FAQ title here",
      answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      date: "12 Jan 2024",
      status: true
    }
  ];

  const cmsPages = [
    { id: 1, name: "Legal", status: true, date: "12 Jan 2024" },
    { id: 2, name: "Privacy Policy", status: true, date: "12 Jan 2024" },
    { id: 3, name: "Terms & Conditions", status: true, date: "12 Jan 2024" },
    { id: 4, name: "Customer Privacy Policy", status: true, date: "12 Jan 2024" },
    { id: 5, name: "About Us", status: true, date: "12 Jan 2024" },
    { id: 6, name: "Data Deletion Policy", status: true, date: "12 Jan 2024" },
  ];

  return (
    <>
      <div className="main_title">
        <h1>CMS Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - CMS Management
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Contact Support" {...a11yProps(0)} />
              <Tab label="CMS Pages" {...a11yProps(1)} />
              <Tab label="FAQ's" {...a11yProps(2)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <form className="form">
            <div className="gap_p">
              <div className="control_group w_50">
                <label htmlFor="email">Email Address</label>
                <TextField
                  id="email"
                  fullWidth
                  hiddenLabel
                  placeholder="Enter here"
                />
              </div>
              <div className="control_group w_50">
                <label htmlFor="phone">Phone Number</label>
                <PhoneInput
                  country={"in"}
                  placeholder="Enter Phone Number"
                  enableSearch={false}
                  autoFormat={false}
                  inputStyle={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="form_btn">
              <Button className="btn btn_primary">Save</Button>
            </div>
          </form>
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={1}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </div>
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => {
                  setIsEdit(false);
                  setOpenModal2(true);
                }}
              >
                <AddIcon /> Add CMS Page
              </Button>
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Page Name</TableCell>
                  <TableCell>Enable/Disable</TableCell>
                  <TableCell>Last Edited</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {cmsPages.map((item) => (
                  <TableRow hover key={item.id}>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>
                      <SwitchToggle defaultChecked />
                    </TableCell>
                    <TableCell>{item.date}</TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton
                          onClick={() => {
                            setIsEdit(true);
                            setOpenModal2(true);
                          }}
                        >
                          <img src="/static/images/edit2_icon.svg" alt="" />
                        </IconButton>
                        <IconButton>
                          <img src="/static/images/trash2_icon.svg" alt="" />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>

            </Table>
          </TableContainer>
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={2}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </div>
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => {
                  setIsEdit(false);
                  setOpenModal(true);
                }}
              >
                <AddIcon /> Add FAQ
              </Button>
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Sr.no</TableCell>
                  <TableCell>Question</TableCell>
                  <TableCell>Answer</TableCell>
                  <TableCell>Created Date</TableCell>
                  <TableCell>Enable/Disable</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {faqList.map((item, index) => (
                  <TableRow hover key={item.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{item.question}</TableCell>
                    <TableCell className="max_c2">
                      <p>{item.answer}</p>
                    </TableCell>
                    <TableCell>{item.date}</TableCell>
                    <TableCell><SwitchToggle defaultChecked /></TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton
                          onClick={() => {
                            setIsEdit(true);
                            setOpenModal(true);
                          }}
                        >
                          <img src="/static/images/edit2_icon.svg" alt="" />
                        </IconButton>

                        <IconButton>
                          <img src="/static/images/trash2_icon.svg" alt="" />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
      </div>

      <AddFaq
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
        isEdit={isEdit}
      />

      <AddCMSPage
        open={openModal2}
        onClose={handleCloseModal2}
        setOpen={setOpenModal2}
        isEdit={isEdit}
      />
    </>
  );
};

export default ManageCms;
